import { discriminatedUnion, literal, object, preprocess } from 'zod';

import { AwardType } from '@occc-app/offerHelpers/types';
import { AwardPointsSchema, AwardVouchersWithExpirationDaysSchema } from '@occc/validation';

export const AwardPointsVariantSchema = object({
  awardType: literal(AwardType.AwardPoints),
  awardPoints: preprocess((data) => data ?? {}, AwardPointsSchema),
});

export const AwardVouchersVariantSchema = object({
  awardType: literal(AwardType.AwardVouchers),
  awardVouchers: preprocess((data) => data ?? {}, AwardVouchersWithExpirationDaysSchema),
});

export const ChallengeAwardSchema = discriminatedUnion('awardType', [
  AwardPointsVariantSchema,
  AwardVouchersVariantSchema,
]);
